import { QueryClient } from '@tanstack/react-query';

/**
 * React-Query client for the Baluarte CRM.
 *
 *  - 30s stale time keeps the UI snappy without hammering the backend.
 *  - Errors are NOT retried automatically — for a CRUD-heavy app, retrying a
 *    failed write is dangerous (it can produce duplicate rows under unique
 *    constraint failures, etc.). The user retries explicitly.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
